import { GetEligibleProgramResponse } from 'api/brand/useGetEligibleProgram';
import { PointEligibleProgram } from '@kouto/types';

const isHyattEligible = (eligibleProgram?: GetEligibleProgramResponse) => {
  if (
    eligibleProgram &&
    Object.values(eligibleProgram)[0]?.org === PointEligibleProgram.FIND
  ) {
    return {
      payEligible: Object.values(eligibleProgram)[0]?.payEligible,
      earnEligible: Object.values(eligibleProgram)[0]?.earnEligible,
    };
  }
  return undefined;
};

export default isHyattEligible;
